import React, { lazy } from 'react';
const Sidebar = lazy(() => import('../../sidebar'));

export function SuiteSideBar() {
    return <Sidebar />;
}
